import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import MainPage from "./components/MainPage/MainPage";
import AboutUs from "./components/AboutUs/AboutUs";
import Contact from "./components/Contact/Contact";
import Offer from "./components/Offer/Offer";
import News from "./components/News/News";
import UnderControl from "./components/Offer/moreOffers/yourBiznesUnderControl/underControl";
import CyberSec from "./components/Offer/moreOffers/cyberSec/cyberSec";
import Taxes from "./components/Offer/moreOffers/taxes/taxes";
import Tech from "./components/Offer/moreOffers/tech/tech";
import Marketing from "./components/Offer/moreOffers/marketing/marketing";
import Finances from "./components/Offer/moreOffers/finances/finances";
import ScrollToTop from "./components/ScrollToTop";
import Specialist from "./components/Specialists/strategy/specialist";
import TechSpecialist from "./components/Specialists/techSpec/techSpec";
import FinanceSpecialist from "./components/Specialists/financeSpec/financeSpec";
import TaxSpecialist from "./components/Specialists/taxSpec/taxSpec";
import FusionSpecialist from "./components/Specialists/fusionSpec/fusionSpec";
import LawSpecialist from "./components/Specialists/lawSpec/lawSpec";
import HResourcesSpecialist from "./components/Specialists/hResourcesSpec/hResourcesSpec";
import MarketingSpecialist from "./components/Specialists/marketingSpec/marketingSpec";
import DevelopmentSpecialist from "./components/Specialists/developmentSpec/developmentSpec";
import ProductionSpecialist from "./components/Specialists/productionSpec/productionSpec";
import LogisticSpecialist from "./components/Specialists/logisticSpec/logisticSpec";
import UEfundsSpecialist from "./components/Specialists/UEfundsSpec/UEfundsSpec";
import Biznes from "./components/Offer/moreOffers/biznes/biznes";
import HR from "./components/Offer/moreOffers/HR/HR";
import Logistic from "./components/Offer/moreOffers/logistic/logistic";
import Transformation from "./components/Offer/moreOffers/transformation/transformation";
import Economic from "./components/Offer/moreOffers/economic/economic";
import Article from "./components/Article/Article";
import GlobalWidowsFixer from "./GlobalWidowsFixer/GlobalWidowsFixer";
import useIsMobile from "./hooks/useIsMobile";

const getCurrentLang = () => {
  try {
    const m = document.cookie.match(/(?:^|;\s*)googtrans=\/pl\/([a-z-]+)/i);
    return m?.[1] || "pl";
  } catch {
    return "pl";
  }
};

const loadGoogleTranslateScript = () =>
  new Promise((resolve) => {
    if (window.__gtInitialized) return resolve();

    const cbName = "__googleTranslateElementInit";
    window[cbName] = () => {
      try {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "pl",
            includedLanguages: "pl,en",
            autoDisplay: false,
          },
          "google_translate_container"
        );
        window.__gtInitialized = true;
      } catch {}
      resolve();
    };

    if (window.google?.translate?.TranslateElement) {
      window[cbName]();
      return;
    }
    if (window.__gtScriptLoading) return resolve();
    window.__gtScriptLoading = true;

    const s = document.createElement("script");
    s.src =
      "https://translate.google.com/translate_a/element.js?cb=__googleTranslateElementInit";
    s.async = true;
    s.onerror = () => resolve();
    document.body.appendChild(s);
  });

const waitForCombo = () =>
  new Promise((resolve) => {
    const existing = document.querySelector(".goog-te-combo");
    if (existing) return resolve(existing);

    const timeout = setTimeout(() => {
      obs && obs.disconnect();
      resolve(null);
    }, 5000);

    const obs = new MutationObserver(() => {
      const el = document.querySelector(".goog-te-combo");
      if (el) {
        clearTimeout(timeout);
        obs.disconnect();
        resolve(el);
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  });

const applyLanguage = async (lang) => {
  const combo = await waitForCombo();
  if (combo) {
    if (combo.value !== lang) {
      combo.value = lang;
      combo.dispatchEvent(new Event("change"));
    }
    return;
  }
  const value = `/pl/${lang}`;
  const host = window.location.hostname;
  document.cookie = `googtrans=${value};path=/`;
  document.cookie = `googtrans=${value};domain=.${host};path=/`;
  try {
    localStorage.setItem("googtrans", value);
  } catch {}
  window.location.reload();
};

const TranslateManager = () => {
  const [lang, setLang] = useState("pl");
  const isMobile = useIsMobile(825);

  useEffect(() => {
    const onWindowError = (message, source) => {
      if (
        message === "Script error." ||
        (source && /translate|google/i.test(source))
      ) {
        return true;
      }
    };
    const captureHandler = (e) => {
      if (
        e?.message === "Script error." ||
        /translate|google/i.test(e?.filename || "")
      ) {
        e.preventDefault?.();
        e.stopPropagation?.();
        return true;
      }
    };
    const prevOnError = window.onerror;
    window.onerror = onWindowError;
    window.addEventListener("error", captureHandler, true);

    const style = document.createElement("style");
    style.textContent = `
      .goog-te-banner-frame,
  .goog-te-balloon-frame,
  .goog-tooltip,
  .goog-tooltip:hover,
  .skiptranslate iframe[title="Language Translate"],
  .VIpgJd-yAWNEb-VIpgJd-fmcmS,
  .VIpgJd-yAWNEb-hvhgNd,
  .VIpgJd-ZVi9od-ORHb,
  .VIpgJd-ZVi9od-l4eHX-hSRGPd,
  .VIpgJd-ZVi9od-aZ2wEe,
  .VIpgJd-ZVi9od-aZ2wEe-OiiCO,
  .VIpgJd-ZVi9od-aZ2wEe-wOHMyf {
    display: none !important;
  }

  body { top: 0 !important; }

  #google_translate_container,
  .goog-te-gadget,
  .goog-te-gadget-simple,
  .goog-logo-link,
  .VIpgJd-ZVi9od-ORHb-OEVmcd {
    display: none !important;
  }

  html { position: static !important; }

  .VIpgJd-yAWNEb-VIpgJd,
.VIpgJd-yAWNEb-VIpgJd:hover,
.VIpgJd-yAWNEb-VIpgJd:focus,
.VIpgJd-yAWNEb-VIpgJd-ibnC6b,
.VIpgJd-yAWNEb-VIpgJd-hSRGPd,
.VIpgJd-yAWNEb-VIpgJd-ORHb,
span[class^="VIpgJd-"],
span[class*=" VIpgJd-"],
.goog-text-highlight {
  background: transparent !important;
  box-shadow: none !important;
  outline: 0 !important;
  border-color: transparent !important;
}

.VIpgJd-yAWNEb-VIpgJd::before,
.VIpgJd-yAWNEb-VIpgJd::after,
span[class^="VIpgJd-"]::before,
span[class^="VIpgJd-"]::after {
  display: none !important;
}
    `;
    document.head.appendChild(style);

    loadGoogleTranslateScript().then(() => setLang(getCurrentLang()));

    return () => {
      window.removeEventListener("error", captureHandler, true);
      window.onerror = prevOnError || null;
      document.head.removeChild(style);
    };
  }, []);

  const [isBusy, setIsBusy] = useState(false);

  const toggleLang = async () => {
    if (isBusy) return;
    setIsBusy(true);
    const next = lang === "pl" ? "en" : "pl";
    await applyLanguage(next);
    setTimeout(() => {
      setLang(getCurrentLang());
      setIsBusy(false);
    }, 150);
  };

  return (
    <>
      <div
        id="google_translate_container"
        style={{ position: "absolute", left: "-9999px", width: 0, height: 0 }}
        aria-hidden="true"
      />
      <button
        onClick={toggleLang}
        disabled={isBusy}
        className="notranslate"
        translate="no"
        aria-label={`Change language to ${
          lang === "pl" ? "English" : "Polish"
        }`}
        style={{
          position: "fixed",
          top: 12,
          right: isMobile ? "auto" : 12,
          left: isMobile ? 12 : "auto",
          zIndex: 9999,
          border: "1px solid #e6e8f0",
          borderRadius: 10,
          padding: "8px 12px",
          background: "#fff",
          fontWeight: 600,
          userSelect: "none",
          opacity: isBusy ? 0.6 : 1,
          cursor: isBusy ? "wait" : "pointer",
        }}
      >
        <span className="notranslate" translate="no">
          {lang === "pl" ? "EN" : "PL"}
        </span>
      </button>
    </>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <GlobalWidowsFixer />
      <TranslateManager />
      <div className="App">
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/oNas" element={<AboutUs />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/oferta" element={<Offer />} />
          <Route path="/aktualności" element={<News />} />
          <Route path="/specjalistaDS.strategii" element={<Specialist />} />
          <Route path="/twójBiznesPodKontrolą" element={<UnderControl />} />
          <Route path="/cyberbezpieczeństwo" element={<CyberSec />} />
          <Route path="/podatki" element={<Taxes />} />
          <Route path="/technologia" element={<Tech />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/finanse" element={<Finances />} />
          <Route
            path="/specjalistaDS.technologii"
            element={<TechSpecialist />}
          />
          <Route
            path="/specjalistaDS.finansów"
            element={<FinanceSpecialist />}
          />
          <Route path="/specjalistaDS.podatków" element={<TaxSpecialist />} />
          <Route path="/specjalistaDS.fuzji" element={<FusionSpecialist />} />
          <Route path="/specjalistaDS.prawnych" element={<LawSpecialist />} />
          <Route
            path="/specjalistaDS.zasobówLudzkich"
            element={<HResourcesSpecialist />}
          />
          <Route
            path="/specjalistaDS.marketingu"
            element={<MarketingSpecialist />}
          />
          <Route
            path="/specjalistaDS.rozwoju"
            element={<DevelopmentSpecialist />}
          />
          <Route
            path="/specjalistaDS.produkcji"
            element={<ProductionSpecialist />}
          />
          <Route
            path="/specjalistaDS.logistyki"
            element={<LogisticSpecialist />}
          />
          <Route
            path="/specjalistaDS.funduszyUE"
            element={<UEfundsSpecialist />}
          />
          <Route path="/biznes" element={<Biznes />} />
          <Route path="/HR" element={<HR />} />
          <Route path="/logistyka" element={<Logistic />} />
          <Route path="/transformacja" element={<Transformation />} />
          <Route path="/ekonomia" element={<Economic />} />
          <Route path="/aktualności/:slug" element={<Article />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
